import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../authentication/AuthContext';
import {useStats} from './hooks/useStats';

function formatFocusTime(seconds = 0) {
    if (!seconds) return '0s';

    if (seconds < 60) return `${seconds}s`;

    if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return remainingSeconds ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`;
    }

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (!minutes) return `${hours}h`;
    return `${hours}h ${minutes}m`;
}

// Simple placeholder analytics dashboard. Replace with real charts/metrics later.
function AnalyticsDashboard() {
    const navigate = useNavigate();
    const {authToken, isLoading: authLoading} = useAuth();
    const dailyQuery = useStats(authToken, 'DAILY');
    const weeklyQuery = useStats(authToken, 'WEEKLY');

    const isStatsLoading = authLoading || dailyQuery.isLoading || weeklyQuery.isLoading;
    const hasStatsError = dailyQuery.error || weeklyQuery.error;

    const dailyStats = dailyQuery.data ?? {
        completedTasks: 0,
        focusSeconds: 0,
    };
    const weeklyStats = weeklyQuery.data ?? {
        completedTasks: 0,
    };

    const dailyFocusTime = hasStatsError ? '—' : formatFocusTime(dailyStats.focusSeconds);
    const weeklyCompletedTasks = hasStatsError ? '—' : weeklyStats.completedTasks;

    return (
        <div className="bg-primary h-[360px] rounded-[8px] ml-4 mt-2 shadow-[0_4px_12px_rgba(0,0,0,0.3)] flex flex-col">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-200 pl-4 pt-4">Analytics</h2>
                <button
                    type="button"
                    className="mr-4 mt-4 text-xs text-gray-400 hover:text-gray-200 transition-colors"
                    onClick={() => navigate('/reports')}
                >
                    View all →
                </button>
            </div>
            <div className="flex-1 overflow-y-auto px-4 pb-4 text-gray-300">
                <div className="mt-4 grid grid-cols-2 gap-4">
                    <div className="surface-alt rounded p-3 text-xs">Daily Focus Time<br/><span className="text-green-400 font-semibold">{isStatsLoading ? 'Loading...' : dailyFocusTime}</span></div>
                    <div className="surface-alt rounded p-3 text-xs">Completed Tasks (Week)<br/><span className="text-blue-400 font-semibold">{isStatsLoading ? 'Loading...' : weeklyCompletedTasks}</span></div>
                </div>
                {/*<div className="mt-6 surface-alt rounded p-4 text-xs">*/}
                {/*    <p className="mb-2 font-semibold text-gray-200">Trend (Placeholder)</p>*/}
                {/*    <div className="h-24 flex items-center justify-center text-[10px] text-gray-500">[ chart ]</div>*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default AnalyticsDashboard;
